import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "./themeSlice";
import languageReducer from "./languageSlice";
import contentReducer from "./contentSlice";
import followReducer from "./followMouseSlice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    language: languageReducer,
    content: contentReducer,
    followMouse: followReducer,
  },
});
